module.exports = __webpack_public_path__ + "assets/img/boil_water_active.db900298.png";